import { SEASON_BADGES_FAILURE, SEASON_BADGES_LOADING, SEASON_BADGES_SUCCESS } from 'redux/reduxConstants';
import { Badge } from 'redux/models/badge';

export function badgesLoading(seasonId: string) {
	return { type: SEASON_BADGES_LOADING, seasonId };
}

export function badgesSuccess(badges: Badge[]) {
	return { type: SEASON_BADGES_SUCCESS, badges };
}

export function badgesFailure(error: string) {
	return { type: SEASON_BADGES_FAILURE, error };
}
